import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const h1AboutFAQ = "Często Zadawane Pytania";

const AboutFAQ = () => {
    const faqData = [
      {
        question: "Godziny Pracy",
        answer: (
          <div style={{ display: 'flex', flexDirection: 'column', width: '60%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <b>Poniedziałek:</b> <span>10-22</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <b>Wtorek:</b> <span>10-22</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <b>Środa:</b> <span>10-22</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <b>Czwartek:</b> <span>10-22</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <b>Piątek:</b> <span>10-22</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <b>Sobota:</b> <span>10-22</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <b>Niedziela:</b> <span>10-22</span>
            </div>
          </div>
        )
      },
        { question: "Jakie jedzenie serwujemy?", answer: "Oferujemy szeroki wybór potraw, które zaspokoją każdy gust. Nasze menu obejmuje wszystko, od klasycznych, wygodnych potraw po dania kuchni międzynarodowej. Niezależnie od tego, czy masz ochotę na świeże sałatki, obfite kanapki, pizzę czy wykwintne przystawki, mamy coś dla każdego. Mamy też coś dla siebie. masz do wyboru opcje wegańskie, wegetariańskie, bezglutenowe i dla alergików. Jeśli masz jakieś specjalne potrzeby lub preferencje dietetyczne, nie wahaj się zapytać, a my dołożymy wszelkich starań, aby spełnić Twoje oczekiwania!" },
        { question: "Jak mogę zamówić online?", answer: "Zamawianie online jest proste! Wystarczy odwiedzić naszą stronę „Zamów teraz” na naszej stronie internetowej. Gdy już tam będziesz, możesz przeglądać nasze pełne menu, wybierać produkty i dodawać je do koszyka. Będziesz mógł wybrać metodę płatności i opcje dostawy. Po złożeniu zamówienia otrzymasz wiadomość e-mail z potwierdzeniem zawierającą szczegółowe informacje." },
    ];

    return (
        <div>
          <div style={{ paddingBottom: '40px', paddingTop: '40px' }}>
            <Typography variant='h1'>{h1AboutFAQ}</Typography>
          </div>
      
          <div>
            {faqData.map((faq, index) => (
              <Accordion key={index}
                sx={{ 
                  boxShadow: 'none',
                  paddingTop: '15px',
                  paddingBottom: '15px',
                  backgroundColor: 'transparent',
                  borderTop: index === 0 ? 'none' : '1px solid #ccc', // No top border for first item
                  borderBottom: index === faqData.length - 1 ? 'none' : '1px solid #ccc', // No bottom border for last item
                  borderLeft: 'none', // Remove left border
                  borderRight: 'none', // Remove right border
                  '&:before': {
                    display: 'none',
                  },
                  '&.Mui-expanded': {
                    margin: 'auto',
                  },
                }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel${index}a-content`}
                  id={`panel${index}a-header`}
                >
                  <Typography>{faq.question}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant='subtitle1'>{faq.answer}</Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
        </div>
      );
};

export default AboutFAQ;